<app-user-dialog
    #userDialog
    (nextClicked)="onUserDialogNext($event)"
/>

<app-coordinator-choice-dialog
    #coordinatorChoiceDialog
    [workerName]="userDialogOutput?.worker?.firstName"
    (joinTeamClicked)="onCoordinatorJoinTeam()"
    (viewTeamsClicked)="onCoordinatorViewTeams()"
/>

<app-team-dialog
    #teamDialog
    [disablePrevious]="disablePreviousTeamDialog"
    (nextClicked)="onTeamDialogClosed($event)"
    (previousClicked)="onTeamDialogPreviousClicked()"
/>

<app-vehicle-dialog
    #vehicleDialog
    (nextClicked)="onVehicleNext($event)"
    (previousClicked)="onVehiclePrevious()"
/>
